import { render, staticRenderFns } from "./NavLinkItem.vue?vue&type=template&id=627016d6&"
import script from "./NavLinkItem.vue?vue&type=script&lang=ts&"
export * from "./NavLinkItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavLinkItem.vue?vue&type=style&index=0&id=627016d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports